import { render, staticRenderFns } from "./OpenVPNServerForm.vue?vue&type=template&id=46fc6b21&"
import script from "./OpenVPNServerForm.vue?vue&type=script&lang=js&"
export * from "./OpenVPNServerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports